import { apiCall } from './gqlClient';
const GETPLANS_QUERY = "\n  query getPlans {\n    getPlans\n    {\n      id\n\t\t\ttitle\n\t\t\toriginalId\n\t\t\tname\n\t\t\tactive\n\t\t\tamount\n\t\t\tinterval\n\t\t\toffers\n\t\t\tdescription\n\t\t\tproviderType\n      ...fragments\n    }\n  }";
export const getPlansApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETPLANS_QUERY,
    variables: {},
    fragments
  });
};